import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import { getColorFromName } from "../../utils/getColor";
import HashLoader from "react-spinners/HashLoader";
import { Trash2Icon } from "lucide-react";
import apiServiceHandler from "../../service/apiService";
import { useDispatch } from "react-redux";
import { updateChatMembers, updateNewChat } from "../../redux/chatData";

const headers = ["Name", "Email", "Action"];

const AllChatMembersModal = ({ isOpen, onClose, chatMembers, chatId }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const dispatch = useDispatch();

  const filteredUsers = chatMembers?.filter((user) => {
    return (
      user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.email.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  const handleMember = async (id) => {
    try {
      const payload = {
        chatId: chatId,
        memberId: id,
        type: "remove",
      };
      const response = await apiServiceHandler(
        "POST",
        "api/chat/update/members",
        payload
      );
      toastr.success(response.message);
      // dispatch(updateNewChat(true));
      dispatch(updateChatMembers(true))
      onClose();
    } catch (error) {
      toastr.error("Please Try Again.");
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered size="xl" className="w-100">
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>Chat Members</Modal.Title>
        <div className="group-modal-search-field">
          <div className="text-input-wrapper">
            <input
              type="text"
              className="text-input"
              placeholder="search by name, email"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <span className="icon">{/* Your Search Icon Here */}</span>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="members-data-table">
          <div className="members-data-table__table">
            {!loading ? (
              <>
                <div className="members-data-table__header">
                  {headers.map((header) => (
                    <div className="data-table__header-cell" key={header}>
                      <div style={{ display: "flex" }}>
                        <span className="header-text-label">{header}</span>
                      </div>
                    </div>
                  ))}
                </div>

                {filteredUsers && filteredUsers.length > 0 ? (
                  filteredUsers.map((user, index) => (
                    <div className="members-data-table__body" key={index}>
                      <div
                        className={`members-data-table__row-${index % 2 === 0 ? "odd" : "even"
                          }`}
                      >
                        <div className="member-data-table__cell--name">
                          <div className="data-table__cell-body">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div
                                className="member-avatar"
                                style={{
                                  backgroundColor: getColorFromName(user.name),
                                }}
                              >
                                <div className="member-avatar__text">
                                  {user.name.substring(0, 1)}
                                </div>
                              </div>
                              <span style={{ marginLeft: "1rem" }}>
                                {user.name}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="member-data-table__cell--email">
                          <div className="member-data-table__cell-body">
                            <div className="member__email">{user.email}</div>
                          </div>
                        </div>
                        <div className="member-data-table__cell--actions">
                          <div className="member-data-table__cell-body">
                            {userDetails?.admin &&
                              userDetails?._id !== user?._id && (
                                <button
                                  className="add__members"
                                  onClick={() => handleMember(user?._id)}
                                >
                                  <Trash2Icon
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      color: "#d1b794",
                                    }}
                                  />
                                </button>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No Members Found</p>
                )}
              </>
            ) : (
              <div className="member-loader">
                <HashLoader color="#d1b794" size={30} />
                <p>Loading Members</p>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>

      <div
        style={
          loading
            ? { display: "none" }
            : {
              display: "flex",
              justifyContent: "center",
              padding: "0px 20px",
              width: "100%",
              alignItems: "center",
            }
        }
      ></div>
    </Modal>
  );
};

export default AllChatMembersModal;
